import { Rol } from "./rol.model";

/**
 * Interface de los documentos generados
 *
 * @export
 * @interface DocumentoGenerado
 */
export interface DocumentoGenerado {
  clasificacion_id: number;
  idtarea?: number;
}

/**
 * Modelo de los documentos de la tarea
 *
 * @export
 * @class Documento
 */
export class Documento {
  clasificacion_id: number;
  clasificacion: string;
  codigo_documento: string;
  documentos_detalle: Array<DocumentoDetalle>;
  funciones: Array<FuncionDocumento>;
  id_tipo_documental: number;
  ruta_generacion: string;
  ruta_vista_previa: string;
  tipo_documental: string;
  documento?: number;
  idtarea?: number;
  expediente?: boolean;
  id_expediente_cita?: number;
  mostrar_radicado_tipo_documental?:boolean;
  mostrar_radicado_sub_serie?:boolean;
  mostrar_radicado_serie?:boolean;
  modificacion?: boolean;
  historial_modificacion?: Array<ModificacionDocumento>;
}

/**
 * Modelo de los solicitantes del formulario
 *
 * @export
 * @class TipoControl
 */
 export class SolicitanteControl {
  id: number;
  usuario: string;
}

/**
 * Modelo de los solicitantes del formulario por documeto
 *
 * @export
 * @class TipoControl
 */
 export class SolicitanteValidacionControl {
  id: number;
  documento?: number;
  subirDocumentos: boolean;
  generarDocumentos: boolean;
}

/**
 * Modelo del documento detalle del documento
 *
 * @export
 * @class DocumentoDetalle
 */
export class DocumentoDetalle {
  fecha?: Date;
  folios?: number;
  historial?: Array<HistorialDocumento>;
  id_documento?: number;
  radicado?: string;
  documento_cita?: string;
  id_documento_cita?: number;
  id_dependencia?:number;
  usuario?: number;
  expediente?: number;
  radicado_expediente?: string;
}
/**
 * Modelo de las funciones del documento
 *
 * @export
 * @class FuncionDocumento
 */
export class FuncionDocumento {
  id_funcion: number;
  obligatorio: boolean;
  funcion: string;
}
/**
 * Modelo del historial del documento
 *
 * @export
 * @class HistorialDocumento
 */
export class HistorialDocumento {
  id: number;
  nombre: string;
  nombre_archivo: string;
  extension: string;
  version: number;
  revision?: Array<RevisionDocumento>;
  radicado?: boolean;
  tarea_origen?: number;
  usuario?: number;
}
/**
 * Modelo de las revisiones del historial del documento
 *
 * @export
 * @class RevisionDocumento
 */
export class RevisionDocumento {
  id_revision: number;
  id_tarea: number;
  reponsable_id: number;
  nombre_tarea?: string;
  descripcion?: string;
  nombre_responsable?: string;
  apellidos_responsable?: string;
  fecha: string;
  revision: boolean;
  historial_id?: number;
  version?: number;
  opcion: number;
}
/**
 * modelo de informacion de revisiones para el endpoind reviewDocument
 *
 * @export
 * @class Revision
 */
export class Revision {
  descripcion: string;
  documento_historial: number;
  tarea?: number;
  responsable?: number;
  revision: boolean;
  opcion: number;
  metodo?: string;
  codigo?: string;
  firma?: boolean;
  convertir_pdf?: boolean;
  autoinsertar_firma?: boolean;
}

/**
 * Modelo de los documentos asociados de la tarea en automatizacion de procesos
 *
 * @export
 * @class DocumentoAsociarTarea
 */
export class DocumentoAsociarTarea {
  documento: number;
  clasificacion?: string;
  tipo_documental?: string;
  funciones?: Array<FuncionDocumento>;
}

/**
 * Modelo de la consulta de radicados a CITA
 *
 * @export
 * @class RadicadoCita
 */
export class RadicadoCita {
  iddocumento: number;
  radicado: string;
  nombre_archivo: string;
  fecha: string;
  fecha_original?: Date;
}

/**
 * Modelo del documento asociado a la tarea
 *
 * @export
 * @class DocumentoAsociado
 */
export class DocumentoAsociado {
  id_documento: number;
  funciones: Array<FuncionDocumento>;
}

/**
 * Modelo del documento asociado de una tarea en un grupo de tareas asociadas
 *
 * @export
 * @class DocumentoAsociadoGrupo
 * @extends {DocumentoAsociado}
 */
export class DocumentoAsociadoGrupo extends DocumentoAsociado {
  id_tarea: number;
}

/**
 * Modelo de la consulta de los documentos por defecto
 *
 * @export
 * @class DefaultDocument
 */
export class DefaultDocument {
  id: number;
  nombre: string;
  tipo_documental: string;
  subserie: string;
  serie?: string;
}

/**
 * Modelo de un documento anexado
 *
 * @export
 * @class DocumentoAnexo
 */
export class DocumentoAnexo {
  id?: number;
  nombre: string;
  version: number;
  fecha_registro: string;
}

/**
 * Modelo para las series de documentos
 *
 * @export
 * @class SeriePredeterminada
 */
export class SeriePredeterminada {
  id?: number;
  nombre: string;
  codigo: string;
  expediente?: Boolean;
}

/**
 * Modelo para los tipos de qr de documentos
 *
 * @export
 * @class QRTypes
 */
 export class QRTypes {
  id?: number;
  nombre: string;
  descripcion: string;
}

/**
 * Modelo para las categorias de qr de documentos
 *
 * @export
 * @class QRCategorias
 */
 export class QRCategorias {
  id?: number;
  nombre: string;
}

/**
 * Modelo para las categorias de qr de documentos
 *
 * @export
 * @class TypePreviewSticker
 */
 export class TypePreviewSticker {
  id?: number;
  nombre: string;
}

/**
 * Modelo para las subseries de documentos
 *
 * @export
 * @class SubSeriePredeterminada
 */
export class SubSeriePredeterminada {
  id?: number;
  nombre: string;
  codigo: string;
  serie?: SeriePredeterminada;
  expediente?: Boolean;
}

/**
 * Modelo para el tipo documental
 *
 * @export
 * @class TipoDocumentalPredeterminado
 */
export class TipoDocumentalPredeterminado {
  id?: number;
  nombre: string;
  codigo?: string;
  subserie?: SubSeriePredeterminada;
  expediente?: Boolean;
  ruta_generacion?: boolean;
  rutas?: RutasTipoDocumental[];
}

/**
 * Modelo Rutas para los documentos de la clasificación documental
 *
 * @export
 * @class Rutas
 */
export class RutasTipoDocumental {
  id?: number;
  ruta_generacion: string;
}
/**
 * Modelo clasificación para la API
 *
 * @export
 * @class ClasificacionPredeterminadaAPI
 */
export class ClasificacionPredeterminadaAPI {
    id?: number;
    nombre: string;
    tipo_documental: TipoDocumentalPredeterminado;
    rutas?: Rutas[];
    solicitud?: boolean;
}

/**
 * Modelo clasificación
 *
 * @export
 * @class ClasificacionPredeterminada
 * @extends {ClasificacionPredeterminadaAPI}
 */
export class ClasificacionPredeterminada extends ClasificacionPredeterminadaAPI {
    ruta_vista_previa?: boolean;
    ruta_generacion?: boolean;
}


/**
 * Modelo Rutas para los documentos de la clasificación documental
 *
 * @export
 * @class Rutas
 */
export class Rutas {
    id?: number;
    ruta_vista_previa: string;
    ruta_generacion: string;
}

/**
 * Modelo de permisos tipo documental
 *
 * @export
 * @class PermisosTipoDocumental
 */
 export class PermisosTipoDocumental {
  id: number;
  tipo_documental?: TipoDocumentalPredeterminado;
  subserie?: SubSeriePredeterminada;
  serie?: SeriePredeterminada;
  rol: Rol;
 }
 /**
 * Modelo de soportes documentales
 *
 * @export
 * @class SoporteDocumental
 */
  export class SoporteDocumental {
    id: number;
    nombre: Text;
    alias: Text
  }

  /**
 * Modelo de valoracion documental
 *
 * @export
 * @class ValoracionDocumental
 */
 export class ValoracionDocumental {
  id: number;
  tipo_documental?: TipoDocumentalPredeterminado;
  subserie?: SubSeriePredeterminada;
  serie: SeriePredeterminada;
  soporte: SoporteDocumental;
  ag: number;
  ac: number;
  ct?: boolean;
  e?: boolean;
  md?: boolean;
  s?: boolean;
  procedimiento?: Text;
}

/**
 * Modelo de dependencia
 *
 * @export
 * @class Dependencia
 */
 export class Dependencia {
  id: number;
  nombre: Text;
  codigo?: Text;
}


  /**
 * Modelo de dependencia por estructura documental
 *
 * @export
 * @class DocumentoDependencia
 */
   export class DocumentoDependencia {
    id: number;
    depdencia: Dependencia;
    tipo_documental?: TipoDocumentalPredeterminado;
    subserie?: SubSeriePredeterminada;
    serie: SeriePredeterminada;
    
  }

    /**
   * Modelo de inventario documental
   *
   * @export
   * @class DocumentoInventario
   */
     export class DocumentoInventario {
      id: number;
      depdencia: string;
      tipo_documental?: string;
      subserie?: string;
      serie: string;
      radicado?: string;
      fecha_documento: string;
      fecha_vencimiento: string;
      expediente: string;
      fecha_expediente: string;
      fecha_asociacion: string;
    }


     /**
   * Modelo de inventario documental
   *
   * @export
   * @class DocumentoInventarioExpediente
   */
      export class DocumentoInventarioExpediente {
        id: number;
        id_documento: number;
        numero: string;
        fecha: string;
      }

       /**
   * Modelo de inventario documental
   *
   * @export
   * @class DocumentoInventario
   */
     export class DocumentoExpedienteInventario {
      id: number;
      depdencia: string;
      numero?: string;
      fecha: string;
      expediente: string;
      fecha_expediente: string;
      fecha_asociacion: string;
    }

    /**
     * Modelo de modifiacion de documento
     */
    export class ModificacionDocumento {
        id: number;
        fecha: string;
        version: number;
        motivo: string;
        responsable: any;
        responsable_aprobacion: any;
        fecha_aprobacion: string;
        motivo_rechazo: string;
        aprobacion: boolean;
        tarea: number;
        documento_modificado: number;
        tipo_documental?: string;
        clasificacion?: string;
        nombre?: string;
    }

   


// WEBPACK FOOTER //
// ./src/app/shared/models/documento.model.ts